import React, { useState, useEffect } from 'react';
import Loading from '../../Common/Loading';
import CustomAlert from '../../Common/CustomAlert';

const API_BASE = process.env.REACT_APP_DOCUMENT_LINK || 'https://staging.sysadmin.elearnoncloud.com/';

const ROLE_CONFIG = [
  // ─────────────────────────────────────────
  // COLUMN 1: ADMIN
  // ─────────────────────────────────────────
  { id: "00", col: 1, label: "ADMIN" },

  // { id: "1", col: 1, label: "Set Site Status" },
  { id: "2", col: 1, label: "Manage Site Message" },
  // { id: "3", col: 1, label: "Clear Idle Seats" },
  { id: "4", col: 1, label: "Manage Program Updates" },
  { id: "5", col: 1, label: "Send eMail" },

  { id: "01", col: 1, label: "Customer Login Accounts" },
  { id: "6", col: 1, label: "View" },
  { id: "7", col: 1, label: "Edit" },
  { id: "8", col: 1, label: "Login as another user" },

  { id: "01", col: 1, label: "School/eDealer" },
  { id: "9", col: 1, label: "Display List" },
  { id: "10", col: 1, label: "Add New" },

  { id: "01", col: 1, label: "School" },
  { id: "11", col: 1, label: "Promote Students to Next year" },

  { id: "01", col: 1, label: "eDealer" },
  { id: "12", col: 1, label: "Add Distributor" },
  { id: "13", col: 1, label: "Modify Distributor" },
  { id: "14", col: 1, label: "Login Roles" },

  { id: "01", col: 1, label: "Families" },
  { id: "15", col: 1, label: "Promote Students to Next year" },

  { id: "01", col: 1, label: "YLA" },
  { id: "80", col: 1, label: "YLA_Entry" },

  { id: "01", col: 1, label: "SuperAdmin" },
  { id: "98", col: 1, label: "SysAdmin Tutor List" },


  // ─────────────────────────────────────────
  // COLUMN 2: DATA
  // ─────────────────────────────────────────
  { id: "00", col: 2, label: "DATA" },

  { id: "01", col: 2, label: "DICS" },
  { id: "16", col: 2, label: "DIC Files" },
  { id: "17", col: 2, label: "Keywords" },
  { id: "75", col: 2, label: "YLA Entry" },

  { id: "01", col: 2, label: "Product" },
  { id: "18", col: 2, label: "Products" },
  { id: "19", col: 2, label: "Packages" },
  { id: "20", col: 2, label: "Promotions" },

  { id: "01", col: 2, label: "Messages" },
  { id: "21", col: 2, label: "Weekly Tips" },
  { id: "22", col: 2, label: "WLP Messages" },

  { id: "01", col: 2, label: "Rewards" },
  { id: "23", col: 2, label: "Avatars" },
  { id: "24", col: 2, label: "Comps" },
  { id: "25", col: 2, label: "Stores" },

  { id: "01", col: 2, label: "Maths Doctor" },
  { id: "26", col: 2, label: "Strand/Substrand/Qns" },
  { id: "27", col: 2, label: "Voucher Codes" },
  { id: "28", col: 2, label: "Maths Doctor- Maths Wiz Link" },
  { id: "29", col: 2, label: "View Questions" },
  { id: "30", col: 2, label: "View Exceptions" },
  { id: "31", col: 2, label: "Post Question Category" },

  { id: "01", col: 2, label: "English Check" },
  { id: "87", col: 2, label: "RESET EnglishCheck" },
  { id: "88", col: 2, label: "English Strand/Substrand/Qns" },
  { id: "89", col: 2, label: "English Check- English Wiz Link" },
  { id: "90", col: 2, label: "English Questions" },
  { id: "91", col: 2, label: "English Post Question Category" },
  { id: "95", col: 2, label: "Assign English Check" },

  { id: "01", col: 2, label: "Others" },
  { id: "32", col: 2, label: "View Lesson" },
  // { id: "33", col: 2, label: "View Games" },
  { id: "34", col: 2, label: "Manage States" },


  // ─────────────────────────────────────────
  // COLUMN 3: SUPPORT
  // ─────────────────────────────────────────
  { id: "00", col: 3, label: "SUPPORT" },

  { id: "35", col: 3, label: "Entry" },
  { id: "36", col: 3, label: "View" },
  { id: "79", col: 3, label: "Share Screen" },
  // { id: "37", col: 3, label: "Search Engine - AUS" },
  { id: "38", col: 3, label: "Courtesy Call List" },
  { id: "39", col: 3, label: "Customer Support Entry Details" },
  { id: "40", col: 3, label: "Flags And Alerts" },

  { id: "96", col: 3, label: "MD Analysis Report" },

  { id: "01", col: 3, label: "WLP" },
  { id: "41", col: 3, label: "Create MathsDoctor LessonPlan" },
  { id: "42", col: 3, label: "Create Default LessonPlan - Maths" },
  { id: "92", col: 3, label: "Create EnglishCheck LessonPlan" },
  { id: "43", col: 3, label: "Create Default LessonPlan - English" },
  { id: "44", col: 3, label: "View LessonPlan - Maths" },
  { id: "45", col: 3, label: "View LessonPlan - English" },
  { id: "72", col: 3, label: "Add Lessons to WLP" },
  { id: "46", col: 3, label: "Default WLP running out - Maths" },
  { id: "47", col: 3, label: "Default WLP running out - English" },
  { id: "48", col: 3, label: "MathsDoctor WLP running out" },
  { id: "68", col: 3, label: "Remove lessons from WLP" },
  { id: "69", col: 3, label: "MD started & Not completed" },
  { id: "70", col: 3, label: "Families Registered By APP" },

  { id: "01", col: 3, label: "DNC" },
  { id: "49", col: 3, label: "Add DNC" },
  { id: "50", col: 3, label: "Search DNC" },

  { id: "01", col: 3, label: "Others" },
  { id: "51", col: 3, label: "View Points" },
  // { id: "52", col: 3, label: "Show eMails sent to Family" },
  // { id: "53", col: 3, label: "Write Reports" },


  // ─────────────────────────────────────────
  // COLUMN 4: REPORTS
  // ─────────────────────────────────────────
  { id: "00", col: 4, label: "REPORTS" },

  { id: "54", col: 4, label: "Structured Reports" },
  // { id: "55", col: 4, label: "Active Users Chart" },
  { id: "56", col: 4, label: "Tutor Center Usage" },
  { id: "57", col: 4, label: "School Usage" },
  { id: "58", col: 4, label: "Family Usage Analysis" },
  { id: "59", col: 4, label: "Sales Report" },
  { id: "60", col: 4, label: "Login Usage" },

  { id: "100", col: 4, label: "Progress MD Report" },
  { id: "97", col: 4, label: "MDOverall Analysis Report" },

  { id: "01", col: 4, label: "Tutors Report" },
  { id: "76", col: 4, label: "Add Tutor" },
  { id: "71", col: 4, label: "Tutor Entries Report" },
  { id: "73", col: 4, label: "Call And Support" },
  { id: "74", col: 4, label: "CPC Installers Report" },
  { id: "78", col: 4, label: "CS-No Open Tasks" },

  { id: "01", col: 4, label: "YLA Report" },
  { id: "86", col: 4, label: "Live Lessons Report" },

  { id: "01", col: 4, label: "Students work" },
  { id: "61", col: 4, label: "User Diary" },
  { id: "62", col: 4, label: "PT Report" },

  { id: "01", col: 4, label: "Students MD" },
  { id: "63", col: 4, label: "Brick Report" },
  // { id: "64", col: 4, label: "Knowledge Gap Report" },
  { id: "65", col: 4, label: "Navigation Report" },
  // { id: "66", col: 4, label: "Current WLP Report" },
  // { id: "67", col: 4, label: "Performance Report" },

  { id: "01", col: 4, label: "Students EC" },
  { id: "93", col: 4, label: "Navigation Report" },
  { id: "94", col: 4, label: "New EC PDF Report" },


  // ─────────────────────────────────────────
  // COLUMN 5: SALES
  // ─────────────────────────────────────────
  { id: "00", col: 5, label: "SALES" },
  { id: "77", col: 5, label: "Cancel Sale" },


  // ─────────────────────────────────────────
  // COLUMN 6: ANALYSIS
  // ─────────────────────────────────────────
  { id: "00", col: 6, label: "ANALYSIS" },

  { id: "81", col: 6, label: "Lesson Browser" },
  { id: "82", col: 6, label: "Question Performance" },
  { id: "83", col: 6, label: "Lesson Performance" },
  { id: "84", col: 6, label: "Test Performance" },
  { id: "85", col: 6, label: "Test Summary" },

  { id: "01", col: 6, label: "AI" },
  { id: "99", col: 6, label: "Writing Feedback" },
];

const EL_SysAdminRoles: React.FC = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const S = queryParams.get('S') || '';
  const F = queryParams.get('F') || '';
  const L = queryParams.get('L') || '';

  const [permissions, setPermissions] = useState<string>('');
  const [resetMD, setResetMD] = useState(false);
  const [loading, setLoading] = useState(true);
  const [alertInfo, setAlertInfo] = useState({
    show: false,
    message: ''
  });

  document.body.style.backgroundColor = "#fff";

  const styles = {
    container: { fontFamily: 'Arial', fontSize: '14pt', margin: '0px' },
    mainTable: { width: '100%', borderCollapse: 'collapse' as const, border: '1px solid black' },
    columnCell: {
      verticalAlign: 'top' as const, backgroundColor: 'white',
      border: '1px solid black', padding: '5px'
    },
    innerTable: { width: '100%', borderCollapse: 'collapse' as const },
    // VB: Style='background-color:teal; color: white; text-align: center;'
    headerCell: {
      backgroundColor: 'teal', color: 'white',
      textAlign: 'center' as const,
      padding: '2px'
    },
    // VB: Style='color:blue; text-align: left;' + <u><b>
    subHeaderCell: {
      color: 'blue', textAlign: 'left' as const,
      textDecoration: 'underline' as const,
      padding: '2px'
    },
    itemCell: { textAlign: 'left' as const, padding: '2px' },
    labelRed: { color: 'red' },
    labelBlack: { color: 'black' },
    button: { width: '100px', height: '30px', cursor: 'pointer' }
  };

  // --- Load permissions & resetMD ---
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(`${API_BASE}api/sysadmin-roles-get/?S=${S}&F=${F}&L=${L}`);
        const data = await res.json();
        if (data.error) {
          setAlertInfo({
            show: true,
            message: data.error
          });
        } else {
          setPermissions(data.permissions || '');
          setResetMD(data.resetMD || false);
        }
      } catch (err) {
        setAlertInfo({
          show: true,
          message: "Error loading roles"
        });
      } finally {
        setLoading(false);
      }
    };
    if (S && F && L) fetchData();
    else setLoading(false);
  }, [S, F, L]);

  // --- VB: Mid(Permissions, CInt(ID), 1) = "Y"  →  permissions[id-1] === 'Y' ---
  const isChecked = (id: string): boolean => {
    const idx = parseInt(id) - 1;
    return idx >= 0 && idx < permissions.length && permissions[idx] === 'Y';
  };

  // --- VB: fn_SetColor + update hidpermissions via fn_Roles ---
  const handleCheckboxChange = (id: string, checked: boolean) => {
    const idx = parseInt(id) - 1;
    let chars = permissions.split('');
    // Pad to at least idx+1 chars (VB string grows as needed)
    while (chars.length <= idx) chars.push('N');
    chars[idx] = checked ? 'Y' : 'N';
    setPermissions(chars.join(''));
  };

  const handleSave = async () => {
    const MAX_ID = 100;

    const padded = permissions.split('');

    while (padded.length < MAX_ID) {
      padded.push('N');
    }

    const finalPermissions = padded.slice(0, MAX_ID).join('');

    try {
      const res = await fetch(`${API_BASE}api/sysadmin-roles-save/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          S,
          F,
          L,
          permissions: finalPermissions,
          resetMD,
        }),
      });

      const data = await res.json();

      if (data.error) {
        setAlertInfo({
          show: true,
          message: data.error,
        });
        return;
      }

      // Same as VB:
      // Update_Roles()
      // -> fn_CollectPermissions()
      // -> fn_CreateCheckBoxes()

      const refetch = await fetch(
        `${API_BASE}api/sysadmin-roles-get/?S=${S}&F=${F}&L=${L}`
      );

      const fresh = await refetch.json();

      if (fresh.error) {
        setAlertInfo({
          show: true,
          message: fresh.error,
        });
        return;
      }

      setPermissions(fresh.permissions || '');
      setResetMD(fresh.resetMD === true);

      setAlertInfo({
        show: true,
        message: data.status || 'User roles updated successfully',
      });

    } catch (err) {
      setAlertInfo({
        show: true,
        message: 'Save Failed',
      });
    }
  };

  const handleBack = () => {
    window.location.href = `EL_ListUsers?S=${S}&F=${F}&L=${L}`;
  };

  // --- Group config by column number ---
  const columns: Record<number, typeof ROLE_CONFIG> = {};
  let maxCol = 0;
  ROLE_CONFIG.forEach(item => {
    if (!columns[item.col]) columns[item.col] = [];
    columns[item.col].push(item);
    if (item.col > maxCol) maxCol = item.col;
  });

  if (loading) return <Loading />;

  return (
    <div style={{ textAlign: 'center', ...styles.container }}>

      {/* Main roles table — mirrors VB <table valign='top' border=1 cellpadding=5 cellspacing=0 width=100%> */}
      <div style={{ textAlign: 'center', fontFamily: 'Arial', fontSize: '14pt' }}>
        <table style={styles.mainTable} cellPadding={5} cellSpacing={0}>
          <tbody>
            <tr>
              {Array.from({ length: maxCol }, (_, i) => i + 1).map(colNum => (
                <td key={colNum} style={styles.columnCell}>
                  {/* VB: inner <table border=0 cellpadding=2 cellspacing=0 width=100%> */}
                  <table style={styles.innerTable} cellPadding={2} cellSpacing={0}>
                    <tbody>
                      {(columns[colNum] || []).map((role, idx) => {
                        if (role.id === "00") {
                          // VB: Style='background-color:teal; color: white; text-align: center;'><b>
                          return (
                            <tr key={idx}>
                              <td style={styles.headerCell}>
                                <b>{role.label}</b>
                              </td>
                            </tr>
                          );
                        } else if (role.id === "01") {
                          // VB: Style='color:blue; text-align: left;'><u><b>
                          return (
                            <tr key={idx}>
                              <td style={styles.subHeaderCell}>
                                <u><b>{role.label}</b></u>
                              </td>
                            </tr>
                          );
                        } else {
                          // VB: <input type=checkbox id=chk{ID} checked onclick='fn_SetColor({ID})'>
                          //     <span id=spn{ID} style='color:red'>{label}</span>
                          const checked = isChecked(role.id);
                          return (
                            <tr key={idx}>
                              <td style={styles.itemCell}>
                                <input
                                  type="checkbox"
                                  id={`chk${role.id}`}
                                  checked={checked}
                                  onChange={(e) => handleCheckboxChange(role.id, e.target.checked)}
                                />
                                &nbsp;
                                <span
                                  id={`spn${role.id}`}
                                  style={checked ? styles.labelRed : styles.labelBlack}
                                >
                                  {role.label}
                                </span>
                              </td>
                            </tr>
                          );
                        }
                      })}
                    </tbody>
                  </table>
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>

      {/* VB: T762 chkResetMD — mirrors <asp:CheckBox Text="RESET Maths Doctor"> */}
      <div style={{ textAlign: 'center', padding: '10px', width: '58%', margin: '0 auto' }}>
        <label style={{ fontFamily: 'Arial', fontSize: 'large' }}>
          <input
            type="checkbox"
            checked={resetMD}
            onChange={(e) => setResetMD(e.target.checked)}
          />
          {' '}RESET Maths Doctor
        </label>
      </div>

      {/* VB: btnSubmit + btnBack */}
      <div style={{ textAlign: 'center', padding: '10px' }}>
        <br />
        <button onClick={handleSave} style={styles.button}>Save</button>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <button onClick={handleBack} style={styles.button}>Back</button>
      </div>
      {alertInfo.show && (
        <CustomAlert
          message={alertInfo.message}
          onClose={() =>
            setAlertInfo({
              ...alertInfo,
              show: false
            })
          }
        />
      )}
    </div>
  );
};

export default EL_SysAdminRoles;